import columns from '../../../../../react-table/helpers/columns';
import { sumTotal } from '../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    DateTimeColumn,
    TextColumn,
    ExternalDespatchLinkColumn,
    NonZeroNumberColumn,
  } = columns(data);
  return [
    {
      Header: '',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'predesWithDespatchS8IdAndLastTransportLeg.despatchS8Id')
          .withWidth(210)
          .withTotalHeader('Total')),
      ],
    },
    {
      Header: 'Last leg',
      columns: [
        new TextColumn('Conveyance reference', 'predesWithDespatchS8IdAndLastTransportLeg.lastTransportLeg.name')
          .withWidth(155),
        new DateTimeColumn('Planned arrival date', 'predesWithDespatchS8IdAndLastTransportLeg.lastTransportLeg.scheduledLocalDateTime')
          .withWidth(145),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NonZeroNumberColumn('Dangerous goods', 'particularContent.countDangerousGoodsReceptacles')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Documents included', 'particularContent.countContainsDespatchDocReceptacle')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Non returnable', 'particularContent.countIsNotToBeReturnedReceptacle')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Returned', 'particularContent.countReturnedReceptacle')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Exempt', 'particularContent.countIsExemptFromTerminalDuesReceptacle')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Registered', 'particularContent.countRegisteredReceptacle')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Insured', 'particularContent.countInsuredReceptacle')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Express', 'particularContent.countExpressReceptacle')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Total', 'particularContent.countTotalReceptacle')
          .withTotalHeader(sumTotal),
      ],
    },
    {
      Header: 'Items',
      columns: [
        new NonZeroNumberColumn('Registered', 'particularContent.countRegisteredItems')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Insured', 'particularContent.countInsuredItems')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Express', 'particularContent.countExpressItems')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Total', 'particularContent.countTotalItems')
          .withTotalHeader(sumTotal),
      ],
    },
  ];
};
